// 🔒
import { termsOfServiceSections } from "../data/termsOfService";

export default function TermsOfServicePage() {
  return (
    <>
      <section className="legal-hero section">
        <div className="container legal-hero__content">
          <p className="eyebrow">LEGAL</p>
          <h1>Terms of Service</h1>
          <p className="legal-hero__description">
            These Terms of Service explain the rules, responsibilities, and
            conditions that apply when users and trainers access the platform,
            website, and related services.
          </p>
        </div>
      </section>

      <section className="legal-content section" id="terms-content">
        <div className="container legal-content__layout">
          <aside className="legal-sidebar">
            <p className="legal-sidebar__label">On this page</p>

            <nav
              className="legal-sidebar__nav"
              aria-label="Terms of service sections"
            >
              {termsOfServiceSections.map((section) => (
                <a key={section.id} href={`#terms-section-${section.id}`}>
                  {section.title}
                </a>
              ))}
            </nav>

            <div className="legal-sidebar__card">
              <h3>Terms at a glance</h3>
              <p>
                These terms govern the use of the platform and outline the
                expectations, rights, and responsibilities that apply to all
                users and trainers.
              </p>
            </div>
          </aside>

          <div className="legal-article">
            <div className="legal-article__meta">
              <span>Effective date: April 7, 2026</span>
            </div>

            {termsOfServiceSections.map((section) => (
              <article
                key={section.id}
                id={`terms-section-${section.id}`}
                className="legal-section"
              >
                <h2>{section.title}</h2>

                {section.content.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
// 🔒